import { HttpClient, HttpMethod } from '@bolteu/http-client';
import {
  TranslationsApiClient,
  TranslationsRequestParams,
  TranslationsServiceResponse,
} from '@bolteu/translations-service/src/compatibility-types';

export class ProviderPortalTranslationsApiClient implements TranslationsApiClient {
  private httpClient: HttpClient;

  constructor(baseUrl: string) {
    this.httpClient = new HttpClient({ baseUrl });
  }

  public exportFileHttp(query: TranslationsRequestParams): Promise<TranslationsServiceResponse> {
    return this.httpClient.sendRequestRaw({
      path: '/exportFileHttp',
      http_method: HttpMethod.GET,
      query,
    });
  }
}
